import React, { useState, useEffect, useContext } from 'react';
import DataTable from 'react-data-table-component';
import Card from '../../components/card.component';
import { ConfigContext } from '../../context/config.context';
import table from './despachoapp.table';
import funciones from './despachoapp.functions';
import SlideDrawer from './sliderdrawer';
import DataTableExtensions from 'react-data-table-component-extensions';

const DespachoApp = () => {

  const { config } = useContext(ConfigContext);
  const [listado, setListado] = useState([]);
  const [open, setOpen] = useState(false);
  const [detalle, setDetalle] = useState(null);

  useEffect(() => {
    obtenerdespachos();
  },[]);

  const obtenerdespachos = () => {
      funciones.despachos().then((response) => {
            setListado(response);
      });
  }

  const toggle = () => {
      setOpen(!open);
  }

  const detalledespacho = (row) => {
    setDetalle(row);
    setOpen(!open);
  }



  return (
    <>
        <Card>
          <h3>Entregas puerta a puerta</h3>
          <DataTableExtensions
            columns={table.colummnsPaquete(config.prefijo_correlativo_guia, detalledespacho)}
            data={listado}
            export={false}
            print={false}
            filterPlaceholder="Buscar"
            >
              <DataTable
                  noHeader={true}
                  customStyles={table.customStyles}
                  dense={true}
                  pagination={true}
                  noDataComponent="No existen datos registrados para mostrar."
              />
          </DataTableExtensions>
        </Card>
        <SlideDrawer show={open} onClose={toggle} data={detalle}/> 
    </>
  )
}

export default DespachoApp;